import { Component } from '@angular/core';

@Component({
    templateUrl: './windows-not-supported.component.html',
    standalone: false
})
export class WindowsNotSupportedComponent {
    public windowVersion: string;

    constructor() {
        const userAgent = navigator.userAgent;
        if (userAgent.includes('Windows NT 6.3')) {
            this.windowVersion = 'Windows NT 6.3';
        } else if (userAgent.includes('Windows NT 6.2')) {
            this.windowVersion = 'Windows NT 6.2';
        } else if (userAgent.includes('Windows NT 6.1')) {
            this.windowVersion = 'Windows NT 6.1';
        } else if (userAgent.includes('Windows NT 6.0')) {
            this.windowVersion = 'Windows NT 6.0';
        } else if (userAgent.includes('Windows NT 5.2')) {
            this.windowVersion = 'Windows NT 5.2';
        } else if (userAgent.includes('Windows NT 5.1')) {
            this.windowVersion = 'Windows NT 5.1';
        } else if (userAgent.includes('Windows NT 5.0')) {
            this.windowVersion = 'Windows NT 5.0';
        }
    }
}
